gsap.registerPlugin(ScrollTrigger, CustomEase, Observer);
CustomEase.create("myCustomEase", "M0,0 C0.25,0.1 0.25,1 1,1");

function splitTextToSpans(selector) {
  // Get the target element(s)
  const elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    const childNodes = Array.from(element.childNodes);

    const spanifiedNodes = childNodes.map((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        // Split the text content into individual words
        return node.textContent.trim().split(/\s+/).map((word) => {
          if (word === '') return null; // Skip empty words
          const span = document.createElement('span');
          span.textContent = word;
          span.style.display = 'inline-block'; // Set spans to inline-block
          return span;
        }).filter(Boolean); // Remove nulls
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SPAN') {
        // Skip existing spans with meaningful content
        if (node.textContent.trim() !== '') {
          return [node];
        }
        return null; // Ignore empty spans
      } else {
        // Wrap other elements in spans
        const span = document.createElement('span');
        span.appendChild(node.cloneNode(true));
        span.style.display = 'inline-block'; // Set spans to inline-block
        return [span];
      }
    });

    // Flatten the array of nodes and replace the element's content
    const flattened = spanifiedNodes.flat().filter(Boolean); // Remove nulls
    element.innerHTML = ''; // Clear the element
    flattened.forEach((span, index) => {
      element.appendChild(span);
      if (index < flattened.length - 1) {
        element.appendChild(document.createTextNode(' ')); // Preserve spacing
      }
    });
  });
}

splitTextToSpans("[split]")

const codeComps = document.querySelectorAll(".code_comp");

codeComps.forEach((el) => {
  const mask = el.querySelector(".code_mask");

  // Create variables to track mouse position
  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;

  // Update mouse position on mousemove
  document.addEventListener("mousemove", (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
  });

  // Use GSAP to animate CSS variables for the element

  gsap.ticker.add(() => {
    gsap.to(el, {
      "--mouse-x": `${mouseX}px`,
      "--mouse-y": `${mouseY}px`,
      duration: 0.25,
      ease: "power3.out",
    });

    // Animate the code_mask to follow the cursor
    gsap.to(mask, {
      x: mouseX,
      y: mouseY,
      duration: 0.25,
      ease: "power3.out",
    });
  });
});

// GSAP MatchMedia setup
let mm = gsap.matchMedia();

// Define media queries and apply Observer only for non-touch screens
mm.add("(hover: hover) and (pointer: fine)", () => {
  // Observer setup for non-touch screens
  Observer.create({
    type: "pointer", // Tracks mouse pointer movement
    onMove: (self) => {
      // Calculate the speed of pointer movement
      let speed = Math.sqrt(self.deltaX ** 2 + self.deltaY ** 2);

      // Animate an element based on the speed
      gsap.to(".code_comp", {
        opacity: gsap.utils.clamp(0.15, 0.5, speed / 100),
        duration: 0.75,
        ease: "power2.out",
      });
    },
    preventDefault: true, // Prevents default browser behavior if necessary
    allowClicks: true, // Allow normal click interactions
  });
});

// You can add additional media queries here for other device-specific behavior

// Ensure GSAP and ScrollTrigger are loaded

gsap.to(".big-marquee_wrap", {
  x: "-100%",
  duration: 400,
  repeat: -1,
});

// Select all launched_item elements
const processItems = document.querySelectorAll(".launched_item-outer");

processItems.forEach((item) => {
  const trigger = item.querySelector(".launched_trigger");
  const plusIcon = trigger.querySelector(".plus-circle_svg"); // Select the plus icon

  // Create a timeline for each item
  const tl = gsap.timeline({ paused: true });

  // Define the timeline animations
  tl.to(item, {
    height: "auto",
    duration: 0.25,
    ease: "power2.out",
  }).to(
    plusIcon,
    {
      rotate: 45,
      duration: 0.25,
      ease: "power2.out",
    },
    "<"
  ); // "<" ensures this animation runs at the same time as the previous one

  trigger.addEventListener("click", () => {
    // Play or reverse the timeline based on its current state
    if (tl.reversed()) {
      tl.play();
    } else {
      tl.reverse();
    }
  });
});

const codeScroll = gsap.timeline({
  scrollTrigger: {
    trigger: "body",
    start: "top top",
    end: "bottom bottom",
    scrub: 0.2,
    ease: "none",
  },
});

codeScroll.from(".code_text", {
  y: "-150vh",
});

const horizontalLines = gsap.utils.toArray('[data-line="horizontal"]');

console.log(horizontalLines);

gsap.utils.toArray('[data-line="horizontal"]').forEach((element, index) => {
  gsap.from(element, {
    width: "0%",
    opacity: "0.7",
    duration: 1.25,
    ease: "myCustomEase",
    scrollTrigger: {
      start: "top 90%",
      trigger: element,
      scrub: false,
    },
  });
});

// Vertical lines grow in height
gsap.utils.toArray('[data-line="vertical"]').forEach((element, index) => {
  gsap.from(element, {
    height: "0%",
    duration: 1.25,
    opacity: "0.7",
    ease: "myCustomEase",
    scrollTrigger: {
      start: "top 70%",
      trigger: element,
      scrub: false,
    },
  });
});



// time

function updateDateTime() {
  // Select the element with the id "time"
  const timeElement = document.getElementById("time");

  if (!timeElement) {
    console.error("Element with id 'time' not found.");
    return;
  }

  // Function to format date and time
  function formatDateTime(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2); // Last two digits of the year
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  // Function to update the time
  function update() {
    const now = new Date();
    timeElement.textContent = formatDateTime(now);
  }

  // Initial update
  update();

  // Update every minute
  setInterval(update, 60000);
}

// Call the function
updateDateTime();

gsap.from(".project_live", {
  opacity: 0.3,
  duration: 0.85,
  ease: "none",
  yoyo: true,
  repeat: -1,
});


// Magic cursor

function initMagneticEffect() {
  const magnets = document.querySelectorAll('[data-magnetic-strength]');
  if (window.innerWidth <= 991) return;

  let lastX = 0, lastY = 0;

  function moveMagnet(event) {
    const magnet = event.currentTarget;
    gsap.killTweensOf(magnet);

    const bounding = magnet.getBoundingClientRect();
    const strength = parseFloat(magnet.getAttribute('data-magnetic-strength')) || 25;
    const innerTarget = magnet.querySelector('[data-magnetic-inner-target]');
    const innerStrength = parseFloat(magnet.getAttribute('data-magnetic-strength-inner')) || strength;

    const offsetX = Math.max(-strength / 16, Math.min(((event.clientX - bounding.left) / magnet.offsetWidth - 0.5) * (strength / 16), strength / 16));
    const offsetY = Math.max(-strength / 16, Math.min(((event.clientY - bounding.top) / magnet.offsetHeight - 0.5) * (strength / 16), strength / 16));

    gsap.to(magnet, {
      x: offsetX + "em",
      y: offsetY + "em",
      rotate: "0.001deg",
      ease: "power4.out",
      duration: 1.6,
    });

    if (innerTarget) {
      const innerOffsetX = ((event.clientX - bounding.left) / magnet.offsetWidth - 0.5) * (innerStrength / 16);
      const innerOffsetY = ((event.clientY - bounding.top) / magnet.offsetHeight - 0.5) * (innerStrength / 16);

      gsap.to(innerTarget, {
        x: innerOffsetX + "em",
        y: innerOffsetY + "em",
        rotate: "0.001deg",
        ease: "power4.out",
        duration: 2,
      });
    }
  }

  function resetMagnet(event) {
    const magnet = event.currentTarget;
    gsap.killTweensOf(magnet);

    gsap.to(magnet, {
      x: "0em",
      y: "0em",
      ease: "elastic.out(1, 0.3)",
      duration: 1.6,
      clearProps: "transform",
    });

    const innerTarget = magnet.querySelector('[data-magnetic-inner-target]');
    if (innerTarget) {
      gsap.to(innerTarget, {
        x: "0em",
        y: "0em",
        ease: "elastic.out(1, 0.3)",
        duration: 2,
        clearProps: "transform",
      });
    }
  }

  magnets.forEach(magnet => {
    magnet.addEventListener('mousemove', moveMagnet);
    magnet.addEventListener('mouseleave', resetMagnet);
  });
}

initMagneticEffect();


// Buttons 

// Select all buttons
const buttons = document.querySelectorAll(".button, .button-w, .button-arrow");

// Iterate over each button
buttons.forEach((button) => {
  // Select the element with the attribute `button-arrow` inside the button
  const arrow = button.querySelector('[button-arrow]');

  if (arrow) {
    // Create a GSAP timeline for the hover effect
    const timeline = gsap.timeline({ paused: true });

    // Add animation to grow the arrow and decrease its opacity
    timeline.to(arrow, {
      scale: 1.15,
      color: "#7CE421",
      x: "35%",
      duration: 0.125, // Animation duration
      ease: "myCustomEase" // Easing for smoothness
    });

    // Play the timeline on hover over
    button.addEventListener("mouseenter", () => {
      timeline.play();
    });

    // Reverse the timeline on hover out
    button.addEventListener("mouseleave", () => {
      timeline.reverse();
    });
  }
});


const titles = document.querySelectorAll("[data-gsap='title']");

titles.forEach((el) => {
  const spans = el.querySelectorAll("span");

  gsap.from(spans, {
    opacity: 0,
    filter: "blur(1px)",
    y: "-30%",
    duration: 2.25,
    ease: "expo.out",
    stagger: { amount: 0.35, ease: "none" },
    scrollTrigger: { trigger: el },
    delay: 0.25
  });

});

const up = document.querySelectorAll("[data-gsap='up']")

up.forEach(el => {

  gsap.from(el, {
    y: "100%",
    duration: 1.25,
    ease: "myCustomEase",
    scrollTrigger: { trigger: el }
  })

})

const markers = document.querySelectorAll(".marker");

markers
  .forEach((el) => {

    gsap.from(el, {
      width: 0,
      duration: 1.125,
      ease: "expo.inOut",
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
      }
    });

  })


  const menuButton = document.querySelector(".menu_button");
  const menuList = document.querySelector(".menu_list");
  let menuOpenState = false;
  
  const menuButtonTl = gsap.timeline({ paused: true });
  
  menuButtonTl
    .from(".menu_item", {
      y: "1rem",
      rotate: -2,
      stagger: { amount: 0.1 },
      opacity: 0,
      filter: "blur(1px)",
      duration: 0.35,
      ease: "myCustomEase",
    })
    .to("#menu-line-1", {
      y: "2.5px",
      duration: 0.2,
      ease: "expo.in",
    }, "<").to("#menu-line-2", {
      y: "-2.5px",
      duration: 0.2,
      ease: "expo.in",
    }, "<").to("#menu-line-1", {
      duration: 0.3,
      ease: "expo.out",
      rotate: -45
    }).to("#menu-line-2", {
      rotate: 45,
      duration: 0.3,
      ease: "expo.out",
    }, "<")
  
  menuButtonTl.eventCallback("onReverseComplete", () => {
    menuList.classList.add("hidden");
  });
  
  menuButton.addEventListener("click", () => {
    if (!menuOpenState) {
      menuList.classList.remove("hidden");
      menuButtonTl.timeScale(1).play(); // Normal speed when playing
      menuOpenState = true;
  
      // Add event listener for clicking outside
      document.addEventListener("click", handleOutsideClick);
    } else {
      menuButtonTl.timeScale(2).reverse(); // Reverse at 2x speed
      menuOpenState = false;
  
      // Remove event listener for clicking outside
      document.removeEventListener("click", handleOutsideClick);
    }
  });
  
  function handleOutsideClick(event) {
    if (
      !menuButton.contains(event.target) && // Click is outside menu button
      !menuList.contains(event.target) // Click is outside menu list
    ) {
      menuButtonTl.timeScale(2).reverse(); // Reverse at 2x speed
      menuOpenState = false;
  
      // Remove event listener to avoid redundant calls
      document.removeEventListener("click", handleOutsideClick);
    }
  }
  

  const drawImage = document.querySelectorAll("[draw]");

  drawImage.forEach((el) => {
    let img = el.querySelector("img");
    
    const borderRadius = getComputedStyle(el).borderRadius;
    const direction = el.getAttribute("draw");
  
    let clipPathFrom, clipPathTo;
    switch (direction) {
      case "tr": // Top-Right
        clipPathFrom = `inset(0% 0% 100% 100% round ${borderRadius})`;
        clipPathTo = `inset(0% 0% 0% 0% round ${borderRadius})`;
        break;
      case "tl": // Top-Left
        clipPathFrom = `inset(0% 100% 100% 0% round ${borderRadius})`;
        clipPathTo = `inset(0% 0% 0% 0% round ${borderRadius})`;
        break;
      case "bl": // Bottom-Left
        clipPathFrom = `inset(100% 100% 0% 0% round ${borderRadius})`;
        clipPathTo = `inset(0% 0% 0% 0% round ${borderRadius})`;
        break;
      case "br": // Bottom-Right
        clipPathFrom = `inset(100% 0% 0% 100% round ${borderRadius})`;
        clipPathTo = `inset(0% 0% 0% 0% round ${borderRadius})`;
        break;
      default: // Default to "lr" (Left to Right)
        clipPathFrom = `inset(0% 100% 100% 0% round ${borderRadius})`;
        clipPathTo = `inset(0% 0% 0% 0% round ${borderRadius})`;
    }
  
    const tl = gsap.timeline({
      scrollTrigger: { trigger: el },
      delay: 0.125,
    });
  
    tl.fromTo(
      el,
      {
        clipPath: clipPathFrom,
      },
      {
        clipPath: clipPathTo,
        duration: 1.5,
        ease: "expo.inOut",
      }
    ).from(
      img,
      {
        scale: 1.1,
        duration: 1.5,
        ease: "expo.inOut",
      },
      "<"
    );
  });
  